export const Platforms = {
  App: 'app',
} as const

export type PlatformsType = (typeof Platforms)[keyof typeof Platforms]
